import React from "react";
import { useTranslation } from "react-i18next";
import { BaseOrderColumn } from "./BaseOrderColumn";
import { Order } from "../../types/model";

interface DoneOrderColProps {
  orders: Order[];
  renderOrder: (order: Order) => React.ReactNode;
  renderOrderTitle?: (order: Order) => React.ReactNode;
  renderOrderDetails: (order: Order) => React.ReactNode;
  showHeading?: boolean;
  elemsMaxHeight?: string;
}

const DoneOrderCol: React.FC<DoneOrderColProps> = ({
  orders,
  renderOrder,
  renderOrderTitle,
  renderOrderDetails,
  showHeading,
  elemsMaxHeight,
}) => {
  const { t } = useTranslation();

  return (
    <BaseOrderColumn
      orders={orders}
      renderOrder={renderOrder}
      renderOrderTitle={renderOrderTitle}
      renderOrderDetails={renderOrderDetails}
      emptyDescription={t("no_orders")}
      heading={t("completed")}
      showHeading={showHeading}
      elemsMaxHeight={elemsMaxHeight}
    />
  );
};

export default DoneOrderCol;
